// extracted by mini-css-extract-plugin
export default {"productGallery":"eP-z","inQuickShop":"fP-z"};